import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import { rootRoute } from './root'

const Affiliate1076 = lazyRouteComponent(() => import('../pages/affiliate-1076'))

export const affiliate1076Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/1076',
  component: Affiliate1076,
})
